import { useState } from 'react';
import { Menu, X } from 'lucide-react';
import './TopBar.css';

export default function TopBar() {
    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

    return (
        <>
            {/* TOP NAVBAR */}
            <header className="top-bar">
                {/* LEFT: LOGO + NAVIGATION */}
                <div className="top-bar-left">
                    {/* LOGO WRAPPER */}
                    <div className="logo-wrapper">
                        <img
                            src="/images/adduplogo.png"
                            alt="Addup Commerce"
                            className="logo-image"
                        />

                    </div>

                    {/* NAVIGATION (DESKTOP) */}
                    <nav className="top-nav">
                        {/* Mockups */}
                        <div className="nav-tab-wrapper">
                            <a href="#" className="nav-tab active">Mockups</a>
                        </div>
                    </nav>
                </div>

                {/* RIGHT: PROFILE ICON + MOBILE MENU BUTTON */}
                <div className="top-bar-right">
                    {/* PROFILE ICON (DESKTOP) */}
                    <div className="profile-avatar"></div>

                    {/* MOBILE MENU BUTTON */}
                    <button
                        className="mobile-menu-button"
                        onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
                        aria-label="Toggle menu"
                    >
                        {isMobileMenuOpen ? (
                            <X size={24} className="text-gray-700" />
                        ) : (
                            <Menu size={24} className="text-gray-700" />
                        )}
                    </button>
                </div>
            </header>

            {/* MOBILE DROPDOWN MENU */}
            {isMobileMenuOpen && (
                <div className="mobile-menu">
                    <nav className="mobile-nav">
                        <a href="#" className="mobile-nav-item active">Mockups</a>
                    </nav>

                    {/* PROFILE ICON MOBILE */}
                    <div className="mobile-profile">
                        <div className="profile-avatar"></div>
                    </div>
                </div>
            )}
        </>
    );
}
